import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';

interface RestrictedRouteProps {
  children: React.ReactElement;
}

/**
 * 비활성 계정 접근 차단 (근무확인서 제외)
 * 활성 계정만 접근 가능한 페이지에 사용
 */
const RestrictedRoute: React.FC<RestrictedRouteProps> = ({ children }) => {
  const { user, isAuthenticated, isLoading } = useAuth();

  // 로딩 중
  if (isLoading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-base-dawn">
        <div className="text-center">
          <div className="animate-spin rounded-full h-16 w-16 border-t-4 border-b-4 border-accent mx-auto mb-4"></div>
          <p className="text-gray-600">로딩 중...</p>
        </div>
      </div>
    );
  }

  // 인증되지 않으면 로그인 페이지로
  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  // 비활성 계정은 홈으로 리다이렉트 (안내 메시지 표시)
  if (user && !user.isActive) {
    return <Navigate to="/" replace />;
  }

  // 활성 계정만 페이지 표시
  return children;
};

export default RestrictedRoute;
